import { TextSortBy } from "nystem-components";

const IntSortBy = (props) => <TextSortBy {...props} />;
export default IntSortBy;
